module.exports = __webpack_public_path__ + "static/media/booking-cards.f08008b3.svg";